(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiqys-duo-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wiqys-bundle]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = root.querySelector('[data-wiqys-bundle-form]');
    const status = root.querySelector('[data-wiqys-status]');
    const button = form.querySelector('button[type="submit"]');
    const variants = JSON.parse(root.querySelector('[data-wiqys-variants]').textContent);
    const variantMap = new Map();
    const currency = root.dataset.currency || 'GBP';
    const discountPercent = Number(root.dataset.discountPercent || 0);

    variants.forEach((variant) => {
      variantMap.set(variant.options.join('|').toLowerCase(), variant);
    });

    const getVariant = (style, color, size) => variantMap.get([style, color, size].join('|').toLowerCase());
    const formatMoney = (amount) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);

    const updatePrice = () => {
      const color = form.elements['bundle-color'].value;
      const regular = getVariant('Regular', color, form.elements['regular-size'].value);
      const jogger = getVariant('Jogger', color, form.elements['jogger-size'].value);
      const total = Math.round(Number(regular?.price || 0) * 100 + Number(jogger?.price || 0) * 100);
      const discountedTotal = Math.round(total * (100 - discountPercent) / 100);
      root.querySelectorAll('[data-wiqys-compare-price]').forEach((price) => {
        price.textContent = formatMoney(total);
      });
      root.querySelectorAll('[data-wiqys-price]').forEach((price) => {
        price.textContent = formatMoney(discountedTotal);
      });
      button.disabled = !regular || !jogger || !regular.available || !jogger.available;
      status.textContent = button.disabled ? 'Selected sizes are currently unavailable.' : '';
    };

    form.addEventListener('change', updatePrice);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const color = form.elements['bundle-color'].value;
      const regular = getVariant('Regular', color, form.elements['regular-size'].value);
      const jogger = getVariant('Jogger', color, form.elements['jogger-size'].value);
      if (!regular || !jogger) return;

      button.disabled = true;
      status.textContent = 'Adding your duo…';

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: regular.id, quantity: 1, properties: { Bundle: `${color} Duo`, Set: 'Regular' } },
              { id: jogger.id, quantity: 1, properties: { Bundle: `${color} Duo`, Set: 'Jogger' } }
            ]
          })
        });

        if (!response.ok) throw new Error('Bundle could not be added.');

        window.location.href = root.dataset.cartUrl;
      } catch (error) {
        status.textContent = error.message;
        updatePrice();
      }
    });

    updatePrice();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiqys-product-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wiqys-shop]');
    if (!button) return;
    const productDetails = document.querySelector('[id^="ProductInformation-"]');
    if (!productDetails) return;
    productDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
